<template>
  <div>
    <div v-if="!!title" class="flex items-center mb-4">
      <p v-if="titieType === 'small'" style="font-size: 16px; font-weight: 400">{{ title }}</p>
      <h5 v-else-if="isTitleDot"><i class="dot"></i> {{ title }}</h5>
      <h5 v-else style="font-weight: normal">{{ title }}</h5>
      <span v-if="!!popupTitle" class="infoBtn" @click="showPopup = true"> <feather-icon icon="InfoIcon" svgClasses="h-5 w-5" />{{ popupTitle }}</span>
    </div>

    <!-- PC -->
    <div class="pc" :class="onlyPc ? ['block'] : ['hidden', 'xl:block']">
      <!-- 테이블 헤더 -->
      <table>
        <colgroup>
          <col v-if="numbering" width="50" />
          <fragment v-if="typeof tableHeaderTitle === 'string'">
            <col width="100" />
            <col />
          </fragment>
          <fragment v-else>
            <fragment v-for="col in tableHeaderTitle" :key="`col-${col.text}`">
              <col v-for="(cs, _cs_i) in col.colspan || 1" :key="`cs-${col.text}-${_cs_i}`" :width="!!col.widths ? col.widths[_cs_i] : col.width" />
            </fragment>
          </fragment>
          <col v-for="col in tableHeaderCheck" :key="`col-${col.text}`" :width="!!col.width ? col.width : '82'" />
          <col v-for="colNote in tableHeaderNote" :key="`col-tableHeaderNote-${colNote.text}`" :width="!!colNote.width ? colNote.width : '388'" />
        </colgroup>
        <thead>
        <tr>
          <th v-if="numbering">No.</th>
          <th v-if="typeof tableHeaderTitle === 'string'" colspan="2">{{ tableHeaderTitle }}</th>
          <fragment v-else>
            <th v-for="th in tableHeaderTitle" :key="`th-${th.text}`" :colspan="th.colspan ? th.colspan : 1">{{ th.text }}</th>
          </fragment>
          <th v-for="th in tableHeaderCheck" :key="`th-${th.text}`">{{ th.text }}</th>
          <th v-for="colNote in tableHeaderNote" :key="`th-tableHeaderNote-${colNote.text}`">{{ colNote.text }}</th>
        </tr>
        </thead>
        <tbody>
        <fragment v-for="(item, item_i) in list" :key="item_i">
          <!-- header (title 위에 필요한경우 사용 24.03.08 (sen))-->
          <tr v-if="!!item.header" class="title-tr">
            <td :colspan="getColspan" :style="{ backgroundColor: item.headerColor || tableTitleColor }">
              <span v-html="item.header" />
            </td>
          </tr>
          <!-- Title  (중복될 경우 무시한다) -->
          <tr v-if="!!item.title && (item_i === 0 || list[item_i].title !== list[item_i - 1].title)" class="title-tr">
            <td :colspan="getColspan" :style="{ backgroundColor: item.titleColor || tableTitleColor }">
              <div class="flex">
                <span v-html="item.title" />
                <span class="infoBtn" v-if="item.titleInfo" @click="()=> { showPopup = true; infoTitle = item.titleInfo}">
                  <feather-icon icon="InfoIcon" svgClasses="h-5 w-5" />
                  {{item.titleInfo}}
                </span>
              </div>
            </td>
          </tr>
          <!-- SubTitle / Content -->
          <tr v-if="item.rowType === 'textarea'">
            <td :colspan="getColspan" class="content">
              <div class="flex items-start gap-4">
                <p style="width: 114px" class="font-medium py-3">{{ item.content }}</p>
                <span v-if="isPrint" class="print-textarea">{{ item[item.content] }}</span>
                <ml-textarea v-else class="flex-1 w-full mb-0" rows="5" :readonly="isReadonly" :placeholder="item.placeholder" v-model="item[item.content]" />
              </div>
            </td>
          </tr>
          <tr v-else>
            <td v-if="numbering" class="text-center">{{ ++item_i }}</td>
            <!-- SubTitle 있을 때 -->
            <td v-if="!!item.subTitle && list[item_i].subTitle !== (!!list[item_i - 1] && list[item_i - 1].subTitle)" :rowspan="getRowSpan(item)" :style="{ backgroundColor: item.subTitleColor }" class="sub-title">{{ item.subTitle }}</td>
            <!-- Content : STRING -->
            <td
              v-if="typeof item.content === 'string'"
              :colspan="!!item.subTitle ? 1 : 2"
              class="content"
              :class="item.contentClass"
              :style="{ padding: !!item.sign ? '10px 14px' : '', backgroundColor: item.contentBackgroundColor || '' }"
            >
              <div style="white-space: pre-line; align-items: start">
                <div v-if="!item.notContentBefore">
                  <span v-if="!!contentBefore && contentBefore === 'numbering'" class="content-before">{{ ++item_i }}. </span>
                  <span v-else-if="!!contentBefore" class="content-before">{{ contentBefore }}</span>
                </div>
                <ml-input v-if="item.content_input" class="w-full" v-model="item.content" :readonly="isReadonly" />
                <p v-else v-html="item.content"></p>
                <div v-for="_sign in item.sign" :key="`${item_i}_sign_${_sign.name}`" class="flex items-center gap-1">
                  <span :style="{ width: _sign.nameWidth, ..._sign.nameStyle }" style="width: max-content">{{ _sign.name }} : </span>
                  <ml-input v-model="_sign.value" :style="{ width: _sign.valueWidth }" />
                </div>
                <!-- gsnd에서 추가한 라디오 버튼 -->
                <div v-if="item.rowType === 'radio'" class="flex items-center gap-4">
                  <vs-radio v-for="crd in item.contentRadio" :key="`${title}-${item_i}-content-radio-${crd.value}`" v-model="item.isChecked" :vs-value="crd.value" :vs-name="`${title}-${item_i}-content-radio`">
                    {{ crd.text || crd.value }}
                  </vs-radio>
                </div>
                <div v-if="item.rowType === 'customContent'" class="flex items-center">
                  <slot name="customContent" />
                </div>
              </div>
            </td>
            <!-- Content : ARRAY -->
            <td
              v-else
              v-for="(content, content_i) in item.content"
              :key="`content_${content_i}`"
              :rowspan="item.rowspan && item.rowspan[content_i] ? item.rowspan[content_i] : '1'"
              v-show="true
                  /* content !== ''*/
                  /* boardId : 249 페이지에서 주말·휴일작업 선택시 테이블이 표기되지 않은 문제가 있어서 항상 보이도록 수정 함*/
              "
              class="content"
              :style="{ padding: !!item.sign ? '10px 14px' : '', backgroundColor: item.contentBackgroundColor || '' }"
            >
              <div style="white-space: pre-line" :style="typeof tableHeaderTitle === 'object' && tableHeaderTitle[content_i] ? tableHeaderTitle[content_i].style : ''">
                <span v-if="contentBefore && contentBefore[content_i] && contentBefore[content_i] === 'numbering'" class="content-before">{{ numberingArray(item_i, content_i) }}. </span>
                <span v-else-if="contentBefore && contentBefore[content_i]" class="content-before">{{ contentBefore[content_i] }}</span>
                <p v-if="typeof content === 'string'" v-html="content"></p>
                <div v-else class="flex flex-wrap items-center gap-x-2 gap-y-4">
                  <div v-for="cc in content" :key="cc.content" style="min-width: 130px">
                    <PrintCheckbox v-if="isPrint" :label="cc.content" :value="cc.check" style="width: fit-content" class="mx-auto" />
                    <vs-checkbox v-else :disabled="isReadonly" v-model="cc.check">{{ cc.content }}</vs-checkbox>
                  </div>
                </div>
                <fragment v-if="!!item.sign && signColIndex === content_i">
                  <div v-for="_sign in item.sign" :key="`${item_i}_sign_${_sign.name}`" class="flex items-center gap-1" :class="_sign.valueWidth === '100%' && 'w-full'">
                    <span :style="{ width: _sign.nameWidth, ..._sign.nameStyle }" style="width: max-content">{{ _sign.name }} :</span>
                    <ml-input v-model="_sign.value" :style="{ width: _sign.valueWidth }" />
                  </div>
                </fragment>
              </div>
            </td>

            <!-- Checkbox -->
            <td v-for="cb in tableHeaderCheck" :key="`cb-${cb.text}`">
              <PrintCheckbox v-if="isPrint" label="" :value="item.isChecked === cb.text" style="width: fit-content" class="mx-auto" />
              <vs-checkbox v-else :disabled="isReadonly" :checked="item.isChecked === cb.text" @change="item.isChecked = cb.text" class="i-check justify-center" />
            </td>
            <!-- Checkbox Note -->
            <td v-for="(colNote, colNote_i) in tableHeaderNote" :key="`td-tableHeaderNote-${colNote.text}`" class="px-1">
              <span v-if="isPrint  && item.rowType !== 'customType'" class="print-input"> {{ item[colNote.text] }} </span>
              <!-- gsnd에서 추가한 라디오 버튼 -->
              <div v-else-if="colNote_i === 0 && item.rowType === 'radio'" class="flex items-center gap-4 p-4">
                <vs-radio v-for="rrd in item.noteRadio" :key="`${title}-${item_i}-note-radio-${rrd.value}`" v-model="item[colNote.text]" :vs-value="rrd.value" :vs-name="`${title}-${item_i}-note-radio`">
                  {{ rrd.text || rrd.value }}
                </vs-radio>
              </div>

              <div v-else-if="item.rowType === 'customType' &&
              item.customIndex === undefined?
              colNote_i===0 : !Array.isArray(item.customIndex)?
               colNote_i === item.customIndex : item.customIndex.includes(colNote_i)">
                <slot name="customType" :trData="item" :noteIndex="colNote_i" :input="(data) => customTypeInput(item_i, item.id, data)"></slot>
              </div>
              <ml-input v-else class="w-full flex-1" v-model="item[colNote.text]" :readonly="isReadonly" :placeholder="colNote.text" />
            </td>
          </tr>
        </fragment>

        <!-- TrFooter -->
        <tr v-if="!!trFooter || $slots.trFooter" class="footer-tr">
          <td :colspan="getColspan">{{ trFooter }} <slot name="trFooter" /></td>
        </tr>
        </tbody>
      </table>

      <div v-if="isBottomNote" class="flex items-center mt-4">
        <div class="label-text mr-4">{{ bottomNoteTitle }}</div>
        <p v-if="isPrint" class="w-full flex-1">{{ bottomNote }}</p>
        <ml-textarea v-else class="flex-1 w-full" rows="5" :readonly="isReadonly" v-model="bottomNote" />
      </div>

      <!-- footer 지정된 경우, 표시한다 (중복될 경우 무시한다) -->
      <div v-if="!!footer" class="p-2" v-html="footer"></div>
    </div>

    <!-- Mobile -->
    <div class="mobile xl:hidden" :class="onlyPc ? ['hidden'] : ['block', 'xl:hidden']">
      <ul>
        <li v-if="typeof tableHeaderTitle === 'string'">{{ tableHeaderTitle }}</li>
        <li v-else>{{ mobileTitle(tableHeaderTitle) }}</li>
        <li v-for="(item, item_i) in list" :key="item_i">
          <p v-if="!!item.title" style="font-weight: 500; font-size: 16px; line-height: 23px" class="mb-3" v-html="item.title"></p>
          <fragment v-if="item.rowType === 'textarea'">
            <p>{{ item.content }}</p>
            <span v-if="isPrint" class="print-textarea">{{ item[item.content] }}</span>
            <ml-textarea v-else style="margin-top: 20px" class="flex-1 w-full" rows="5" :readonly="isReadonly" v-model="item[item.content]" />
          </fragment>
          <fragment v-else>
            <p v-if="typeof item.content === 'string'" v-html="item.content"></p>
            <div v-else v-for="(content, content_i) in item.content" :key="`content_mobile_${content_i}`">
              <p v-if="typeof content === 'string'" v-html="content" class="mb-6"></p>
              <div v-else class="grid grid-cols-2 gap-6 mb-6">
                <div v-for="cc in content" :key="cc.content">
                  <PrintCheckbox v-if="isPrint" :label="cc.content" :value="cc.check" color style="width: fit-content" class="mx-auto" />
                  <vs-checkbox v-else :disabled="isReadonly" v-model="cc.check">{{ cc.content }}</vs-checkbox>
                </div>
              </div>
            </div>
            <div v-for="_sign in item.sign" :key="`${item_i}_sign_${_sign.name}`" class="flex items-center gap-3">
              <span style="width: max-content">{{ _sign.name }} : </span>
              <ml-input v-model="_sign.value" class="flex-1" />
            </div>
            <div v-if="0 < tableHeaderCheck.length" class="btn-container">
              <button v-for="cb in tableHeaderCheck" :key="`mobile-cb-${cb.text}`" type="button" :class="[item.isChecked === cb.text && 'active']" @click="item.isChecked = cb.text">{{ cb.text }}</button>
            </div>
            <fragment v-for="(colNote, colNote_i) in tableHeaderNote" :key="`mobile-td-tableHeaderNote-${colNote.text}`">
              <div v-if="colNote_i === 0 && item.rowType === 'radio'">
                <div class="btn-container">
                  <button v-for="crd in item.contentRadio" :key="`mobile-${title}-${item_i}-content-radio-${crd.value}`" type="button" :class="[item.isChecked === crd.value && 'active']" @click="item.isChecked = crd.value">
                    {{ crd.text || crd.value }}
                  </button>
                </div>
                <div class="btn-container mt-3">
                  <button v-for="rrd in item.noteRadio" :key="`mobile-${title}-${item_i}-note-radio-${rrd.value}`" type="button" :class="[item[colNote.text] === rrd.value && 'active']" @click="() => updateNoteRadio(item_i, rrd.value)">
                    {{ rrd.text || rrd.value }}
                  </button>
                </div>
              </div>
              <div v-else-if="(colNote_i === (item.customIndex !== undefined ? item.customIndex : 0)) && item.rowType === 'customType'">
                <slot name="customType" :trData="item"  :input="(data) => customTypeInput(item_i, item.id, data)"></slot>
              </div>
              <ml-input v-else class="w-full mt-3" v-model="item[colNote.text]" :placeholder="colNote.text" :readonly="isReadonly" />
            </fragment>
          </fragment>
        </li>
      </ul>
    </div>

    <!-- POPUP -->
    <vs-popup class="table-inspect-merge-popup" v-if="popupTitle || infoTitle " :title="popupTitle || infoTitle" :active.sync="showPopup">
      <slot name="popup" :title="popupTitle || infoTitle"></slot>
    </vs-popup>
  </div>
</template>

<script>
import PrintCheckbox from "@/components/print/PrintCheckbox.vue";
export default {
  name: "TableInspectMerge",
  components: { PrintCheckbox },
  props: {
    isPrint: Boolean,
    isReadonly: Boolean,
    onlyPc: Boolean,
    title: String,
    titieType: String,
    isTitleDot: {
      type: Boolean,
      default: true,
    },
    numbering: {
      type: Boolean,
      default: false,
    },
    tableHeaderTitle: {
      type: String | Array,
      default: "점검내용",
    },
    tableHeaderCheck: {
      type: Array,
      default: () => [
        { text: "양호", width: "82" },
        { text: "미흡", width: "82" },
        { text: "해당없음", width: "82" },
      ],
    },
    tableHeaderNote: {
      type: Array,
      default: () => [{ text: "비고(보완계획)", width: "388" }],
    },
    // numbering, -, •, ·
    contentBefore: String | Array,
    footer: String,
    trFooter: String,
    isBottomNote: {
      type: Boolean,
      default: false,
    },
    bottomNoteTitle: {
      type: String,
      default: "기타의견",
    },
    initBottomNote: {
      type: String,
      default: "",
    },
    tableTitleColor: {
      type: String,
      default: null,
    },
    signColIndex: {
      type: Number,
      default: 0,
    },
    popupTitle: String,
    value: Array,
  },
  computed: {
    getColspan() {
      let col = 0;
      if (typeof this.tableHeaderTitle === "string") col = col + 2;
      else col = col + this.tableHeaderTitle.length;

      col = col + this.tableHeaderCheck.length;
      col = col + this.tableHeaderNote.length;

      if (this.numbering) ++col;

      return col;
    },
  },
  data() {
    return {
      bottomNote: this.initBottomNote,
      list: this.value,
      showPopup: false,
      infoTitle: "",
    };
  },
  watch: {
    value: {
      handler(value) {
        this.list = value;
      },
    },
    list: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },

    showPopup(value) {

      // 팝업시 스크롤 막기
      const body = document.querySelector('body');
      if (value) {
        body.style.overflow = 'hidden'
      } else {
        body.style.overflow = 'auto'
      }
    },
  },
  methods: {
    getRowSpan(data) {
      const _row = this.list.filter((item) => item.title === data.title && item.subTitle === data.subTitle);
      return _row.length;
    },
    mobileTitle(data) {
      return data.map((item) => item.text).join(" / ");
    },
    updateNoteRadio(index, value) {
      this.$set(this.list[index], this.tableHeaderNote[0].text, value);
    },
    numberingArray(index, col) {
      let _num = 1;
      for (let i = 0; i < index; i++) {
        if (this.list[i].content[col] !== "") _num++;
      }
      return _num;
    },
    customTypeInput(index, key, data) {
      this.$set(this.list[index], key, data);
    },
  },
};
</script>

<style scoped lang="scss">
.infoBtn {
  display: inline-flex;
  column-gap: 7px;
  color: #7e72f2;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  margin-left: 8px;
}
.i-check::v-deep .vs-checkbox {
  margin: 0;
}
.pc {
  table {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;

    th,
    td {
      border: 1px solid #cdcdcd;
    }

    thead {
      th {
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        text-align: center;
        color: #3c3c3c;
        background: #f9f9f9;
        padding: 16px 0;
      }
    }

    tbody {
      .title-tr td {
        font-weight: 700;
        font-size: 14px;
        line-height: 20px;

        background: #f9f9f9;
        padding: 14px;
      }
      .footer-tr td {
        font-weight: 700;
        font-size: 14px;
        line-height: 20px;

        background: #f9f9f9;
      }
      .sub-title {
        text-align: center;
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;

        background: #f9f9f9;
        padding: 14px 0;
      }

      .content {
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        padding: 14px;

        & > div {
          display: flex;
          flex-wrap: nowrap;
          align-items: center;
          gap: 8px;
        }

        &.empty-style {
          padding: 4px !important;
          & > div {
            display: block;
          }
        }

        &::v-deep {
          .vs-radio--label {
            line-height: 0;
          }
        }
      }
    }
  }
}

.mobile {
  ul {
    li {
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;

      border: 1px solid #cdcdcd;
      padding: 15px;

      &:first-child {
        text-align: center;
        background: #f9f9f9;
      }
      &:nth-child(n + 2) {
        border-top: 0;
      }

      .btn-container {
        display: flex;
        align-items: center;
        border: 1px solid #cdcdcd;
        border-radius: 8px;
        overflow: hidden;
        margin-top: 20px;

        button {
          flex: 1;
          font-family: "Noto Sans KR";
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          line-height: 18px;
          color: #2c2c2c;
          background: none;
          border: 0;
          border-right: 1px solid #cdcdcd;
          outline: 0;
          padding: 11px 0;
          &:last-child {
            border-right: 0;
          }

          &.active {
            color: white;
            background: #200c63;
          }
        }
      }
    }
  }
}
</style>

<style lang="scss">
  .table-inspect-merge-popup > .vs-popup {
    width: auto !important;
    max-width: 80%;
  }
</style>
